import React from 'react';
import './style.scss';
import { findIcon, IconName } from 'views/utils/handleIcon';

type SearchBoxProps = {
  searchWord?: string;
  setSearchWord: (searchWord: string) => void;
  submitSearch: (searchWord: string) => void;
  clearSearch: () => void;
  placeholder?: string;
};

const searchIcon = findIcon(IconName.Search);
const cancelIcon = findIcon(IconName.Cancel);

export const SearchBox = (props: SearchBoxProps) => {
  const { searchWord, setSearchWord, submitSearch, placeholder, clearSearch } = props;

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    submitSearch(searchWord || '');
  };

  return (
    <form className="searchBox" onSubmit={handleSubmit}>
      <button className="searchBox_icon" type="submit" onClick={() => handleSubmit}>
        <img src={searchIcon} alt="icon" />
      </button>
      <input
        className="searchBox_input"
        type="search"
        inputMode="search"
        value={searchWord}
        onChange={(e) => setSearchWord(e.target.value)}
        placeholder={placeholder}
        onBlur={() => {
          submitSearch(searchWord || '');
        }}
      />
      {/* cssのwebkitでブラウザデフォルトのxボタンは非表示にした状態でxの画像を配置している */}
      {searchWord && (
        <button className="searchBox_cancelIcon" onClick={clearSearch}>
          <img src={cancelIcon} alt="icon" />
        </button>
      )}
    </form>
  );
};
